<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">{{ t('contact_teacher') }}</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>
    <div class="p-4">
      <div v-for="option in contactOptions" :key="option.id" class="d-flex align-items-center gap-3 p-4 bg_white rounded-4 mb-3 shadow-sm">
        <input :id="option.id" name="ticket" type="radio" :value="option.label" v-model="selectedTitle">
        <label :for="option.id">{{ option.label }}</label>
      </div>
      
      <label for="description" class="font_normal bold mb-3">{{ t('msg_text') }}</label>
      <textarea id="description" class="w-100 p-4 mb-4 rounded-4 border_gray" rows="8" v-model="caption" :placeholder="t('write_explanation')"></textarea>
      
      <div class="d-flex align-items-center justify-content-center">
        <button class="button" @click="submitTicket" :disabled="loading">
          {{ loading ? t('send_otp') : t('submit_continue') }}
        </button>
      </div>
    </div>
    <div class="w-100 max_width d-flex justify-content-end position-fixed bottom-3 p-3">
      <img src="@/assets/imgs/whatsapp.svg" class="icon-size-8 cursor-pointer" alt="" @click="openWhatsApp">
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'TeacherContactView',
  data() {
    return {
      contactOptions: [
        { id: 'problem_app', label: 'راپور مشکل خاص در اپلیکیشن' },
        { id: 'report_bug', label: 'راپور مشکل تخنیکی' },
        { id: 'edit_profile', label: 'ویرایش پروفایل' },
        { id: 'other', label: 'دیگر موارد' }
      ],
      selectedTitle: '',
      caption: '',
      loading: false
    }
  },
  methods: {
    async submitTicket() {
      if (!this.selectedTitle) {
        this.notify('لطفاً یک موضوع را انتخاب کنید.', 'error');
        return;
      }
      if (!this.caption.trim()) {
        this.notify(this.t('write_explanation'), 'error');
        return;
      }
      
      this.loading = true;
      try {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
          teacher_id: userId,
          title: this.selectedTitle,
          caption: this.caption
        });
        
        const response = await apiClient.post('/teacher/add_ticket', formData);
        
        if (response.data.status === 'ok') {
          this.notify(response.data.message || this.t('successful_submit'), 'success');
          this.selectedTitle = '';
          this.caption = '';
          this.$router.go(-1);
        } else {
          this.notify(response.data.message || this.t('error_submit'), 'error');
        }
      } catch (error) {
        console.error("Error submitting ticket:", error);
        this.notify(this.t('connection_error'), 'error');
      } finally {
        this.loading = false;
      }
    },
    async openWhatsApp() {
      try {
        const formData = createFormData({ action: 'whatsapp' })
        const response = await apiClient.post('/public_info', formData)
        
        let url = ''
        if (typeof response.data === 'string') {
           url = response.data
        } else if (response.data.data) {
           url = response.data.data
        }
        
        if (url) {
           url = url.replace(/"/g, '')
           window.open(url, '_blank')
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.border_gray {
    border: 1px solid #e0e0e0;
    outline: none;
}
.border_gray:focus {
    border-color: #4A00E0;
}
.cursor-pointer {
    cursor: pointer;
}
</style>